import React from 'react';
import { Grid, Typography, Box, FormControlLabel, Checkbox, Paper } from '@mui/material';

const ConsentSection = ({ formData, handleChange, errors }) => {
  const consentItems = [
    { key: 'consent_surgery', label: 'Consent for Surgery *', errorMsg: 'Surgery consent is required' },
    { key: 'consent_blood_transfusion', label: 'Consent for Blood Transfusion *', errorMsg: 'Blood transfusion consent is required' },
    { key: 'consent_anesthesia', label: 'Consent for Anesthesia *', errorMsg: 'Anesthesia consent is required' },
  ];

  return (
    <Box sx={{ mt: 3 }}>
      <Typography variant="h6" sx={{ color: '#008080', mb: 2, fontWeight: 'bold' }}>
        Step 7: Informed Consent
      </Typography>
      
      <Grid container spacing={2}>
        {consentItems.map((item) => (
          <Grid item xs={12} sm={4} key={item.key}>
            <Paper variant="outlined" sx={{ p: 2, border: errors[item.key] ? '1px solid #008080' : '1px solid #e0e0e0', borderRadius: 2 }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={formData[item.key] || false}
                    onChange={handleChange}
                    name={item.key}
                    color="primary"
                  />
                }
                label={item.label}
              />
              {errors[item.key] && (
                <Typography variant="caption" color="error" display="block" sx={{ mt: 1 }}>
                  {item.errorMsg}
                </Typography>
              )}
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default ConsentSection;
